import styled from 'styled-components';

export const Container = styled.section`
    .content {
        margin-bottom: 6em;

        button {
            width: 100%;
            max-width: 100%;
        }

        p {
            margin-bottom: 2em;
        }
        label {
            display: flex;
            flex-direction: column;
            margin-bottom: 1em;

            p {
                margin: 0;
                font-size: 16px;
            }

            input, select, textarea {
                width: 100%;
                border: 1px solid #B2B2B2;
                padding-left: 10px;
                height: 45px;
                line-height: 45px;

                &::placeholder {
                    color: #C8C8C8;
                }
            }

            span.require {
                color: tomato;
                font-size: 14px;
                padding-top: 2px;
            }
        }
    }    

    .separator {
        display: block;
        border-bottom: 2px solid var(--secundary-color);
        margin-bottom: 2em;
    }
`